module.exports = __webpack_public_path__ + "img/face-weary.f212189e.svg";